import { forwardRef, type Ref, type SVGProps } from "react";
const IconTabletFilledSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" d="M26 2H6a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2M16 28a1 1 0 1 1 1-1 1 1 0 0 1-1 1m10-4H6V4h20z" /></svg>;
const ForwardRef = forwardRef(IconTabletFilledSVG);
ForwardRef.displayName = "IconTabletFilled";
export { ForwardRef as IconTabletFilled };